import { Routes, Route, useParams } from "react-router-dom";

import Application from "../Profile/Application/index";
import ApplicationPreview from "../Profile/Application/Preview";

import ApplicationView from "./Applications/ApplicationView";
import { JobContent } from "./JobCard/tabs/JobContent";
import { CompanyProfile } from "./JobCard/tabs/CompanyProfile";

import Jobs from ".";

import { CandidateRoute } from "@otta/search/utils/routing/CandidateRoute";
import { PreferencesSetRoute } from "@otta/search/utils/routing/PreferencesSetRoute";
import { Redirect } from "@otta/search/router";
import { useApplyAvailability } from "@otta/search/hooks/useApplyAvailability";

function RedirectFromSectors() {
  const { sectorTagId, jobId } = useParams();

  return (
    <Redirect
      to={{
        pathname: jobId ? `/jobs/${jobId}` : "/jobs",
        search: `?theme=preferred-sector&sector-id=${sectorTagId}`,
      }}
    />
  );
}

// While internal applications are switched off, send anyone landing on the
// apply flow (e.g. from an email or bookmark) back to the job instead
function InternalApplyGuard({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement {
  const { jobId } = useParams();
  const { internalApplyDisabled } = useApplyAvailability();

  if (internalApplyDisabled) {
    return <Redirect to={`/jobs/${jobId}`} />;
  }

  return children;
}

function RedirectTheme() {
  const { themeId, jobId } = useParams();

  return (
    <Redirect
      to={{
        pathname: jobId ? `/jobs/${jobId}` : "/jobs",
        search: `?theme=${themeId}`,
      }}
    />
  );
}

export default function JobsRoutes(): React.ReactElement {
  return (
    <Routes>
      <Route path="saved" element={<Redirect to="/" />} />
      <Route path="preferences" element={<Redirect to="/preferences" />} />
      <Route
        path=":jobId/apply"
        element={
          <CandidateRoute>
            <InternalApplyGuard>
              <Application />
            </InternalApplyGuard>
          </CandidateRoute>
        }
      >
        <Route>
          <Route index element={<JobContent />} />
          <Route path="company" element={<CompanyProfile />} />
        </Route>
      </Route>
      <Route
        path=":jobId/application"
        element={
          <CandidateRoute>
            <ApplicationView />
          </CandidateRoute>
        }
      />
      <Route
        path=":jobId/apply/preview"
        element={
          <CandidateRoute>
            <InternalApplyGuard>
              <ApplicationPreview />
            </InternalApplyGuard>
          </CandidateRoute>
        }
      />
      <Route
        path="theme/preferred-sector/:sectorTagId"
        element={<RedirectFromSectors />}
      />
      <Route
        path="theme/preferred-sector/:sectorTagId/:jobId"
        element={<RedirectFromSectors />}
      />
      <Route path="theme/:themeId" element={<RedirectTheme />} />
      <Route path="theme/:themeId/:jobId" element={<RedirectTheme />} />
      <Route path="sector/:sectorTagId" element={<RedirectFromSectors />} />
      <Route
        path="sector/:sectorTagId/:jobId"
        element={<RedirectFromSectors />}
      />
      <Route
        path="*"
        element={
          <PreferencesSetRoute
            element={<Jobs />}
            fallback={<Jobs isPublic />}
          />
        }
      />
    </Routes>
  );
}
